"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WelcomeES_component_1 = require("./WelcomeES.component");
exports.WelcomeES = WelcomeES_component_1.WelcomeES;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9Wb2d1ZS9mb3JtL1dlbGNvbWVFUy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZEQUErQztBQUF2QywwQ0FBQSxTQUFTLENBQUEifQ==